module.exports = __webpack_public_path__ + "static/media/grzanie_chlodzenie.42c9d1fd.svg";